import React from "react";
import Projects from "../../components/projects/Projects";
import task from "../../assets/task-management.png";
import webster from "../../assets/webster.png";
import jsonFormat from "../../assets/jsonFormat.png";
import "./project.css";

const ProjectContainer = () => {
  return (
    <div className="projects">
      <h3>Projects :</h3>
      <div className="myProjects">
        <Projects
          title={"WebsterGamely.io - Browser Arcade"}
          projectUrl={"https://webstergamely-io.vercel.app/"}
          img={webster}
          miniDesc={"Full-stack multiplayer browser arcade with 11 games, real-time matchmaking, and score leaderboards"}
          projectInfo={
            "Architected and deployed a comprehensive browser arcade platform featuring 11 playable games (Snake, 2048, Tic Tac Toe, Connect Four, Minesweeper, Memory Match, Reaction Time, Rock Paper Scissors, Word Scramble, Battleship, Typing Master). Implemented real-time multiplayer matchmaking via Socket.IO with queue-based and invite-code systems. Frontend built with React 19 and Vite with GSAP animations and responsive mobile/desktop layouts. Backend initially developed in Node.js/Express, then fully migrated to Spring Boot 3.5 with Java 21 for improved performance and scalability. MongoDB handles persistent score storage with in-memory fallback for offline resilience. Integrated Google OAuth 2.0 authentication, JWT-based session management, and comprehensive leaderboard rankings. Deployed on Render with Docker containerization for CI/CD pipeline. Achieved 70% code coverage with JUnit and Mockito testing frameworks."
          }
          tools={
            "React 19, Vite, GSAP, CSS3, Spring Boot 3.5, Java 21, Gradle, MongoDB, Socket.IO, JWT, Google OAuth, Docker, GitHub, Render"
          }
        />
        <Projects
          title={"JSON Formatter Pro"}
          projectUrl={"https://json-formatter-pro-free.vercel.app/"}
          img={jsonFormat}
          projectInfo={
            "Developed a full-stack JSON processing application that enables users to format, validate, and minify JSON data with real-time updates. Features include a sophisticated code editor powered by Monaco Editor, interactive JSON structure tree visualization, copy-to-clipboard functionality, and downloadable formatted outputs. The application provides seamless validation feedback and supports multiple JSON operations in a single interface."
          }
          miniDesc={
            "Full-stack application for JSON formatting, validation, and visualization with real-time processing"
          }
          tools={
            "React.js, Vite, Spring Boot, Monaco Editor, Jackson, GitHub"
          }
        />
        <Projects
          title={"Task Management App"}
          img={task}
          miniDesc={" Full-stack Web application to efficiently manage tasks"}
          projectInfo={
            " Designed and developed a task management web application featuring CRUD operations for tasks, real-time updates, and a user-friendly interface. The frontend is built with React.js and styled using CSS modules, while the backend is powered by Node.js and Express.js. MongoDB is used as the database to store tasks."
          }
          tools={"React.js, CSS, Node.js, Express.js, MongoDB, GitHub"}
        />
      </div>
    </div>
  );
};

export default ProjectContainer;
